import {
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { SystemProps } from './primitives.types';

export interface DrawerProps extends SystemProps {
  isOpen: boolean;
  onClose: () => void;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  title?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  showCloseButton?: boolean;
}

export function Drawer({
  isOpen,
  onClose,
  placement = 'right',
  size = 'sm',
  title,
  footer,
  children,
  showCloseButton = true,
  p,
  w,
  ...systemProps
}: DrawerProps) {
  return (
    <ChakraDrawer
      isOpen={isOpen}
      placement={placement}
      onClose={onClose}
      size={size}
      {...systemProps}
    >
      <DrawerOverlay />
      <DrawerContent maxWidth={w}>
        {showCloseButton && <DrawerCloseButton />}
        {title && <DrawerHeader>{title}</DrawerHeader>}
        <DrawerBody padding={p}>{children}</DrawerBody>
        {footer && <DrawerFooter>{footer}</DrawerFooter>}
      </DrawerContent>
    </ChakraDrawer>
  );
}